module.exports = __webpack_public_path__ + "static/media/S_S02.89e184ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/S_S02.png
// module id = 110
// module chunks = 0